import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function BehaviouralChangeMbarara() {
  return (
    <div className="art-page">
      <SEO
        title="Behavioural Change Interventions in Cookstove Adoption — Mbarara District"
        description="CIRCODU implemented behavioral research across 64 Mbarara parishes developing targeted messages on health and economic benefits of clean cooking, demonstrating that technology availability alone doesn't drive adoption."
        keywords="behavioral change, cookstove adoption, Mbarara, health benefits, economic incentives, clean cooking, CIRCODU, behavioral research Uganda, cookstove behavioral interventions Uganda, Mbarara cookstove adoption Uganda, health benefits of clean cooking Uganda, economic incentives for clean cooking Uganda, demand-side barriers clean cooking Uganda, supply-side constraints clean cooking Uganda, stove usage monitoring Uganda, indoor air pollution monitoring Uganda, fuel consumption measurement Uganda, household surveys Uganda, focus group discussions Uganda, key informant interviews Uganda, willingness-to-buy assessments Uganda, willingness-to-pay assessments Uganda"
        url="/Behavioural-Change-Interventions-in-Cookstove-Adoption—Mbarara-District"
        datePublished="2012-12-01"
      />

      {/* ── Hero ──────────────────────────────────────── */}\
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Behavioural Change Interventions in Cookstove Adoption — Mbarara
              District
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 01, 2012
            </div>
            <h1 className="art-title">
              Behavioural Change Interventions in Cookstove Adoption — Mbarara
              District
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Between 2011 and 2012, CIRCODU implemented a community-level
                behavioural research programme across{" "}
                <strong>64 parishes in Mbarara District</strong>, commissioned
                by <strong>Impact Carbon</strong> with <strong>USAID</strong>{" "}
                support. The project focused on developing and disseminating
                targeted behavioural messages around the health benefits and
                economic savings associated with clean cooking — grounded in the
                recognition that technology availability alone is insufficient
                to drive adoption. People must be meaningfully motivated to
                change cooking practices they have followed for generations.
              </p>
              <p>
                The global development community has increasingly recognised
                that demand-side barriers are as important as supply-side
                constraints in determining whether improved cookstoves reach and
                remain in homes. This project placed CIRCODU at the frontier of
                that understanding, combining message development with rigorous
                impact measurement.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU's work spanned both the communication and measurement
                dimensions of the programme:
              </p>
              <ol>
                <li>
                  <strong>Communication:</strong> CIRCODU developed and
                  delivered behavioural messaging campaigns emphasising time and
                  money savings from reduced fuel consumption, as well as the
                  health co-benefits of reduced indoor smoke exposure —
                  particularly for women and young children, who are
                  disproportionately exposed to harmful cooking emissions in
                  traditional households.
                </li>
                <li>
                  <strong>Measurement:</strong> CIRCODU conducted a
                  comprehensive monitoring suite including fuel consumption
                  measurements, indoor air pollution monitoring, stove usage
                  tracking with dedicated usage monitors, household surveys,
                  focus group discussions, key informant interviews, and
                  willingness-to-buy and willingness-to-pay assessments.
                  Together, these tools captured both the reach of the
                  behavioural intervention and its measurable impact on cooking
                  practices and air quality.
                </li>
              </ol>
              <h2 className="art-subheading">Significance</h2>
              <p>
                This project contributed to a growing body of evidence on the
                role of demand-side interventions in clean cooking uptake. By
                combining message development with rigorous impact measurement
                across 64 parishes, CIRCODU demonstrated that behaviour change
                programming — when well-designed and carefully monitored — can
                make a meaningful contribution to sustained stove adoption
                beyond what distribution alone achieves.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's community research and
                behavioural studies, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
